import React from "react";
import "./ExplorebyProgram.css";
import { ExplorebyProgramData } from "./ExplorebyProgramData.jsx";

const ExplorebyProgram = () => {
     
    return (
        <div className="agentic-ai-container-Program">
            <div className="agentic-ai-wrap-Program">
                <div className="heading-box-Program">
                    <h2 className="main-headings">AI Engineers-Gen AI and Agentic AI Programs</h2>
                </div>
                <p className="overview-content-Program">
                    AI is transforming how we drive impact for our clients, making it an essential skill for every
                    practitioner. To future-proof your skills and to harness Generative and Agentic AI to drive breakthrough
                    productivity and reimagine client value - we have launched the <b>Agentic AI training</b>.
                </p>
            </div>
            
            <div className="ExplorebyProgram-container">
                <div className="ExplorebyProgram-wrap">
                    <div className="ExplorebyProgram-components-wrap">
                        {ExplorebyProgramData.map((item) => {
                            return (
                            <div
                                key={item.id}
                                className="ExplorebyProgram-components-row"
                            >
                                <div className="ExplorebyProgram-components-box">
                                <div className="ExplorebyProgram-components-content-box">
                                    <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>
                                        <img
                                            src={item.icon}
                                            alt={item.title}
                                            className="ExplorebyProgram-title-icon"
                                        />
                                    <h3> 
                                        
                                        {item.title}
                                    </h3>
                                    </div>
                                    <ul>
                                        {item.para?.map((point, index) => (
                                            <li key={index}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                                </div>
                            </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="roadMap-container">
                <div className="roadMap-heading">
                        <h3>Follow the roadmap below to continue your AI journey</h3>
                </div>
                <div className="roadMapImage">
                    <img
                        src={process.env.PUBLIC_URL + "/images/AIAcademy/roadmap2026.png"}
                        alt="roadmap"
                        className="roadmap-image"
                    />
                    {/* Text overlays */}
                    <div className="overlay-text genai-essentials">
                    <a href="https://atci.lkm.delivery.accenture.com/TT/Automation/genAI" target="_blank">Gen AI Essentials & Foundation</a>
                        <div className="subtext_l1">(Gen AI for Delivery Practitioner /Automation Architect / Delivery Leads Tech Services Leads - Level 1)</div>
                    </div>

                    <div className="overlay-text genai-design">
                    <a href="https://atci.lkm.delivery.accenture.com/TT/Automation/genAI" target="_blank">Gen AI Design Patterns & Assets</a>
                        <div className="subtext_l1">(Gen AI for Delivery Practitioner /Automation Architect / Delivery Leads Tech Services Leads - Level 2)</div>
                    </div>

                    <div className="overlay-text agentic-ecosystem">
                    <a href="https://atci.lkm.delivery.accenture.com/TT/Automation/agenticAI" target="_blank">Agentic AI Ecosystem Tools</a>
                    <div className="subtext"> ~8 Hrs Recommended<br /></div>
                    <div className="subtext1">+ 37 Hrs Optional</div>
                    </div>

                    <div className="overlay-text agentic-frameworks">
                    <a href="https://atci.lkm.delivery.accenture.com/TT/Automation/agenticAI" target="_blank">Agentic AI Frameworks</a>
                    <div className="subtext"> ~11 Hrs Recommended<br /></div>
                    <div className="subtext1">+ 3 Hrs Optional</div>
                    </div>

                    <div className="overlay-text agentic-cloud">
                    <a disabled style={{opacity: '0.3'}}>Agentic AI Deep Dive Learning</a>
                    <div className="subtext_l1">(For Cloud Engineers, Data Engineers, Enterprise Platform Engineers and Custom Engineers)</div>
                    </div>

                    <div className="overlay-text agentic-assets">
                    <a disabled style={{color: 'black', opacity: '0.3'}}>Agentic AI Accenture Assets</a>
                    </div>
                </div>
            </div>
            <div className="ai-pls-note-container">
                <div className="ai-pls-note-wrap">
                    <div className="ai-pls-note-row">
                        <div className="pls-note-icon-box">
                        <img
                            src={process.env.PUBLIC_URL + "/images/AIAcademy/Icon3.png"}
                            alt="note icon"
                            className="note-icon"
                        />
                        </div>
                        <p className="please-note">
                        <span>*Please Note:</span><br/>
                        1. Eligibility: Practitioners in Career Levels 12 and above who have completed Level 2 of GenAI in TDLC training track.<br/>
                        2. Complete both 3A and 3B to move to the next level
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExplorebyProgram;